import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback, useLayoutEffect } from 'react';
import { useOutsideClickClose } from '../utils/hooks/useOutsideClickClose.web.js';

//TODO: test onKeyDown
var useSelectEventsHandler = function useSelectEventsHandler(selectId) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    selectOpened = _useState2[0],
    setSelectOpened = _useState2[1];
  var setSelectClosed = useCallback(function () {
    setSelectOpened(false);
  }, []);
  var _useOutsideClickClose = useOutsideClickClose(setSelectClosed),
    wrapperRef = _useOutsideClickClose.wrapperRef;
  useLayoutEffect(function () {
    wrapperRef.current = document.getElementById(selectId);
    return function () {
      wrapperRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectId]);
  var onClick = useCallback(function (e) {
    var buttonElement = document.querySelector("#".concat(selectId, ">button"));
    var clickedWithinButton = !!(e.target instanceof Node && buttonElement && buttonElement.contains(e.target));
    setSelectOpened(clickedWithinButton);
  }, [selectId]);

  //istanbul ignore next line
  var onKeyDown = function onKeyDown(ev) {
    if (ev.key === 'Enter') {
      setSelectOpened(false);
    }
  };
  return {
    selectOpened: selectOpened,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onSelect: setSelectClosed
  };
};

export { useSelectEventsHandler };
